import { Paper, Table, TableContainer } from '@mui/material'
import { ObservationLogsTableHead } from './ObservationLogsTableHead'
import { ObservationLogsTableBody } from './ObservationLogsTableBody'
import { ObservationLog } from '@/types'

export type ObservationLogsTableProps = {
  rows: ObservationLog[]
  showObservationLogDetails: (id: number) => void
  selectedIds: number[]
  onToggleSelect: (id: number, isApproved: boolean) => void
  onSelectAll: (items: { id: number; isApproved: boolean }[]) => void
}

export const ObservationLogsTable = ({
  rows,
  showObservationLogDetails,
  selectedIds,
  onToggleSelect,
  onSelectAll,
}: ObservationLogsTableProps): JSX.Element => (
  <TableContainer
    component={Paper}
    data-testid="observation-logs-overview-table"
  >
    <Table stickyHeader={true}>
      <ObservationLogsTableHead
        onSelectAll={() => {
          const items = rows.map((r) => ({
            id: r.id,
            isApproved: r.is_approved,
          }))

          onSelectAll(items)
        }}
        isAllSelected={
          rows.length > 0 && rows.every((r) => selectedIds.includes(r.id))
        }
        isIndeterminate={
          rows.some((r) => selectedIds.includes(r.id)) &&
          !rows.every((r) => selectedIds.includes(r.id))
        }
      />
      <ObservationLogsTableBody
        rows={rows}
        showObservationLogDetails={showObservationLogDetails}
        selectedIds={selectedIds}
        onToggleSelect={onToggleSelect}
      />
    </Table>
  </TableContainer>
)
